import { render } from "./UserLearningProgress.vue?vue&type=template&id=65335a66&scoped=true"
import script from "./UserLearningProgress.vue?vue&type=script&lang=js"
export * from "./UserLearningProgress.vue?vue&type=script&lang=js"

import "./UserLearningProgress.vue?vue&type=style&index=0&id=65335a66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65335a66"]])

export default __exports__